import { Organization } from './organization.model';

export interface Subscription {
  id: string;
  organizationId: string;
  organization?: Organization;
  status: SubscriptionStatus;
  adminSeats: number;
  userSeats: number;
  adminSeatsInUse?: number;
  userSeatsInUse?: number;
  organizationName?: string;
  stripeSubscriptionId?: string;
  stripeCustomerId?: string;
  cancelAtPeriodEnd?: boolean;
  cancelAt?: string;
  canceledAt?: string;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
  createdAt?: string;
  updatedAt?: string;
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  TRIAL = 'TRIAL',
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  PAST_DUE = 'PAST_DUE',
}

export interface GetSubscriptionsInput {
  page: number;
  limit: number;
  search: string;
  filter: string;
  orderBy: string;
  orderDirection: 'ASC' | 'DESC';
}

export interface getSubscriptionsRequest {
  getSubscriptions: {
    subscriptions: Subscription[];
    count: number;
  };
}

export interface CreateSubscriptionSessionInput {
  organizationId: string;
  stripeAdminPriceId: string;
  stripeUserPriceId: string;
  adminSeats: number;
  userSeats: number;
  customerEmail?: string;
  customerName?: string;
  couponCode?: string;
}

export interface SubscriptionSession {
  subscriptionId: string;
  stripeSubscriptionId: string;
  stripeCustomerId: string;
  clientSecret: string;
  adminSeats: number;
  userSeats: number;
  status: string;
}

export interface createSubscriptionSessionRequest {
  createSubscriptionSession: SubscriptionSession;
}

export interface StripePriceConfig {
  adminPriceId: string;
  userPriceId: string;
}

export interface getStripePriceConfigRequest {
  getStripePriceConfig: StripePriceConfig;
}

export interface Invoice {
  id: string;
  organizationId: string;
  subscriptionId?: string;
  stripeId: string;
  stripeSubscriptionId?: string;
  amount: number;
  currency: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface getActiveSubscriptionRequest {
  getActiveSubscription: Subscription | null;
}

export interface getInvoicesByOrganizationRequest {
  getInvoicesByOrganization: Invoice[];
}

export interface UpdateSubscriptionSeatsInput {
  adminSeats: number;
  userSeats: number;
}

export interface updateSubscriptionSeatsRequest {
  updateSubscriptionSeats: Subscription;
}

export interface CancelSubscriptionInput {
  cancelImmediately: boolean;
}

export interface cancelSubscriptionRequest {
  cancelSubscription: Subscription;
}

export interface ValidateCouponInput {
  couponCode: string;
  adminSeats: number;
  userSeats: number;
}

export interface ValidateCouponResponse {
  valid: boolean;
  couponId?: string;
  percentOff?: number;
  amountOff?: number;
  currency?: string;
  duration?: string;
  durationInMonths?: number;
  originalAmount?: number;
  discountAmount?: number;
  finalAmount?: number;
  errorMessage?: string;
}

export interface validateCouponRequest {
  validateCoupon: ValidateCouponResponse;
}

export interface BillingPortalSession {
  url: string;
}

export interface createBillingPortalSessionRequest {
  createBillingPortalSession: BillingPortalSession;
}
